export function OutlinePerifoneoSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0435 14.0957L17.6132 17.6654L17.1598 18.3145L16.3438 17.7418L15.6709 17.2741L13.0842 15.4606C13.404 15.0072 13.7237 14.5491 14.0435 14.0957Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0908 11.1747C16.2292 10.9742 16.3676 10.7786 16.506 10.5781L20.5816 13.4272L19.6606 14.7444"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.61963 7.6721L5.7584 10.3303L3.31494 8.6218L5.47683 5.5293L7.61963 7.6721Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.3412 17.7431L13.0847 15.4629L10.8045 18.7193L14.061 20.9995L16.3412 17.7431Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.61972 7.67188L14.0434 14.0955C13.7236 14.5489 13.4039 15.007 13.0841 15.4604L3.47729 13.5896L5.75849 10.3301L7.61972 7.67188Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.66211 4.74669L10.8886 3C11.7095 4.10719 12.5255 5.20961 13.3464 6.31681C14.4011 7.73421 15.4558 9.15638 16.5057 10.5785C16.3673 10.779 16.2289 10.9747 16.0905 11.1751"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8964 20.9492L17.613 17.6658L14.0433 14.096L7.61967 7.6724L5.47687 5.5296L3 3.05273"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
